import styled from '@emotion/styled';

export const ButtonGroupWrapper = styled.div`
  button {
    width: 100%;
  }
`;
